import { useSelector } from 'react-redux';

import { getUserAvatar } from 'store/selectors';
import Avatar from 'components/avatar';

import userDefaultAvatar from 'assets/images/default-avatar.png';

const UserAvatar = ({ src, size }) => {
  const userAvatar = useSelector(getUserAvatar);

  return <Avatar src={src || userAvatar || userDefaultAvatar} size={size} />;
};

export default UserAvatar;
